import { render, staticRenderFns } from "./VLink.vue?vue&type=template&id=0940adab&scoped=true&"
import script from "./VLink.vue?vue&type=script&lang=js&"
export * from "./VLink.vue?vue&type=script&lang=js&"
import style0 from "./VLink.vue?vue&type=style&index=0&id=0940adab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940adab",
  null
  
)

export default component.exports